import { render, staticRenderFns } from "./ButtonSendPurchaseBuyer.vue?vue&type=template&id=2c74ca02&"
import script from "./ButtonSendPurchaseBuyer.vue?vue&type=script&lang=ts&"
export * from "./ButtonSendPurchaseBuyer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports